





import Vue from 'vue'

export default Vue.extend({
  name: 'PrivateCellRenderer',

  computed: {
    icon (): string {
      // @ts-ignore
      return this.params.data.isPrivate ? 'check' : 'clear'
    },

    color (): string {
      // @ts-ignore
      return this.params.data.isPrivate ? 'green' : 'red'
    }
  }
})
